import React, { useContext, useEffect } from 'react';
import { CreateWatchContext, ICreateWatchContext } from '../../../../createWatchState/createWatchContext';
import { preventDefaultForEnterKey } from 'utils/helpers';
import { Form } from 'antd';
import Text from 'components/Text/Text';
import { SerialNumberField } from './components/SerialNumberField';
import { CustomerField } from './components/CustomerField';
import { RestaurantField } from './components/RestaurantField';
import { BtnBlock } from './components/BtnBlock';
import style from './InputFields.module.scss';

export const InputFields: React.FC = () => {
	const {
		changeSerialNumber,
		setIDCustomer,
		setIDRestaurant,
		setDataForSubmit,
		changeTypeOfModalWindow,
		serialNumber,
		IDSelectedCustomer,
		IDSelectedRestaurant,
	} = useContext<ICreateWatchContext>(CreateWatchContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ serialNumber, IDSelectedCustomer, IDSelectedRestaurant });
	}, [serialNumber, IDSelectedCustomer, IDSelectedRestaurant]);

	const submit = () => {
		setDataForSubmit({
			id: null,
			serialNumber,
			restaurantId: IDSelectedRestaurant,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="serialNumberHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<SerialNumberField changeSerialNumber={changeSerialNumber} />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<CustomerField setIDCustomer={setIDCustomer} IDSelectedCustomer={IDSelectedCustomer} />
					<RestaurantField
						IDSelectedCustomer={IDSelectedCustomer}
						IDSelectedRestaurant={IDSelectedRestaurant}
						setIDRestaurant={setIDRestaurant}
					/>
				</div>
				<BtnBlock />
			</Form>
		</div>
	);
};
